import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { PRESUPUESTOS_ASIGNACION } from 'constants/codigosTransacciones'

import MainPage from './main'

export default function PresupuestosAsignacionPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${PRESUPUESTOS_ASIGNACION}`} component={MainPage} />
      </Switch>
    </Suspense>
  )
}
